import {
	RESEND_CODE,
	ResendCodeType,
	RESEND_CODE_FAIL,
  } from "../../domain/resendCode/index";
import { passwordlessClient } from "../../api/passwordlessClient";
import { ICommandResult } from "../../../Common/domain/src/api/commandResult";
  // in actions folder
  export const resendCodeAction = (result: ICommandResult): ResendCodeType => {
	return {
	  type: RESEND_CODE,
	  payload: result,
	};
  };
  
  export const resendCodeFailAction = (err: ICommandResult): ResendCodeType => {
	return {
	  type: RESEND_CODE_FAIL,
	  payload: err,
	};
  };
  

  
export const handleResendCode = (token: string, phoneNumber: string) => {
	return function (dispatch: any) {
	  const endpoint = new passwordlessClient();
	  endpoint
		.resendCode(token, phoneNumber)
		.then((data) => {
		  dispatch(resendCodeAction(data));
		  return data;
		})
		.catch((err) => {
		  dispatch(resendCodeFailAction(err));
		});
	};
  };
  